import { Route, Switch } from "react-router-dom";
import organisationRoutes from "./routes";
import orgDetailRoutes from "./organisation-detail-routes";
import NotFound from "../../common/NotFound";
import Breadcrumbs from "../../common/Breadcrumbs";

export default function OrganisationsRouter() {
  return (
    <div className="mt-8">
      <Breadcrumbs routes={organisationRoutes.concat(orgDetailRoutes)} />

      <div className="mt-7">
        <Switch>
          {organisationRoutes.map((route) => (
            <Route
              key={route.path}
              exact={route.exact}
              path={route.path}
              component={route.component}
            />
          ))}

          <Route component={NotFound} />
        </Switch>
      </div>
    </div>
  );
}
